import { clsx as o } from "clsx";
import { twMerge as t } from "tailwind-merge";
function m(...r) {
  return t(o(r));
}
export {
  m as c
};
//# sourceMappingURL=cn-B6yFEsav.js.map
